import { useQuery } from 'react-query';
import useCompetitionStore from 'store/competitionStore';
import { getCompetition } from 'api/services/competitions';
import { useEffect } from 'react';
import isEqual from 'lodash/isEqual';

const useCompetition = (competitionId) => {
  const competitionDetails = useCompetitionStore((state) => state.competition.details);
  const competitionError = useCompetitionStore((state) => state.competition.error);

  const setCompetition = useCompetitionStore(
    (state) => state.setCompetition,
  );
  const { data = {}, isLoading, error } = useQuery({
    queryKey: 'competition',
    queryFn: getCompetition(competitionId),
    refetchOnMount: !!competitionId && competitionId !== competitionDetails?.competitionId,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    enabled: !!competitionId && competitionId !== competitionDetails?.competitionId,
  });

  useEffect(() => {
    if (!isEqual(competitionDetails, data) || !isEqual(competitionError, error)) {
      setCompetition(data, isLoading, error);
    }
  }, [data, competitionError, competitionDetails, isLoading, error, setCompetition]);
};

export default useCompetition;
